/*
  Project: pipehouse-shop
  Author: schrittweiter GmbH
 */

import './modules/woocommerce/checkout';
import './modules/woocommerce/quantity';
import './modules/woocommerce/ageValidation';
import './modules/woocommerce/cart-submit';
import './modules/woocommerce/checkout-submit';
